import React, { useState } from 'react';
import { Service, IncidentForm } from '../types';

interface IncidentModalProps {
  service: Service;
  onClose: () => void;
}

export default function IncidentModal({ service, onClose }: IncidentModalProps) {
  const [form, setForm] = useState<IncidentForm>({ email: '', message: '', eta: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!form.email || !form.message) return;
    setSubmitted(true);
    setTimeout(onClose, 2200);
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    background: '#1a1d26',
    border: '1px solid #2a2d3a',
    borderRadius: '8px',
    padding: '0.65rem 0.85rem',
    color: '#fff',
    fontFamily: "'Courier New', monospace",
    fontSize: '0.9rem',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#888',
    fontSize: '0.75rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    marginBottom: '0.4rem',
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#0f1117', border: '1px solid rgba(255,100,50,0.3)', borderRadius: '16px',
          padding: '2rem', width: '100%', maxWidth: '480px', boxShadow: '0 0 60px rgba(255,80,30,0.15)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {submitted ? (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✓</div>
            <p style={{ color: '#a8ff78', fontFamily: "'Courier New', monospace", fontWeight: 700 }}>
              Request logged.
            </p>
            <p style={{ color: '#666', fontSize: '0.85rem', marginTop: '0.5rem' }}>
              We'll notify you when {service.name} is back online.
            </p>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
              <div>
                <p style={{ color: '#ff6432', fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '0.3rem' }}>
                  Incident Report
                </p>
                <h2 style={{ color: '#fff', fontFamily: "'Courier New', monospace", fontSize: '1.15rem', margin: 0 }}>
                  {service.name}
                </h2>
              </div>
              <button
                onClick={onClose}
                style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: '1.2rem' }}
              >
                ✕
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={labelStyle}>Your Email *</label>
                <input
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="you@company.com"
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Expected ETA / Context</label>
                <input
                  value={form.eta}
                  onChange={(e) => setForm({ ...form, eta: e.target.value })}
                  placeholder="e.g. Scheduled maintenance until 14:00 UTC"
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Description *</label>
                <textarea
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="Describe the issue or impact..."
                  rows={3}
                  style={{ ...inputStyle, resize: 'vertical' }}
                />
              </div>
              <button
                onClick={handleSubmit}
                style={{
                  background: 'linear-gradient(135deg, #ff6432, #ff3a6e)', border: 'none', borderRadius: '8px',
                  padding: '0.75rem', color: '#fff', fontFamily: "'Courier New', monospace", fontWeight: 700,
                  fontSize: '0.9rem', letterSpacing: '0.05em', cursor: 'pointer', marginTop: '0.25rem',
                }}
              >
                Log Incident Report →
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
